export default __webpack_public_path__ + "static/media/Photo-Album-Icon.996794f5.png";